import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginAuthGuard } from '../Guards/login-auth.guard';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserComponent } from './user/user.component';


const routes: Routes = [
//{ path: 'edit/admins', component: UserComponent, canActivate: [LoginAuthGuard] },
{ path: 'edit/admins/:action/:id', component: UserDetailsComponent, canActivate: [LoginAuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
